import { render, staticRenderFns } from "./BRegistration.vue?vue&type=template&id=0ae69743&scoped=true&"
import script from "./BRegistration.vue?vue&type=script&lang=js&"
export * from "./BRegistration.vue?vue&type=script&lang=js&"
import style0 from "./BRegistration.vue?vue&type=style&index=0&id=0ae69743&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae69743",
  null
  
)

export default component.exports